/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { includes } from 'lodash';
import { ABeagleContext, AdsContext } from '../../contexts';
import { AdError, whitelistedPages } from '../../constants/ads';
import { getContext } from '../../services/ad';
import { framework, rules, api } from '@buzzfeed/consent';


export default function Ads(props) {
    const [adlib, setAdlib] = useState(null);
    const [listener, setListener] = useState(null);
    // set to null initially, let the children re-render when it's loaded
    const [context, setContext] = useState(null);
    const isWhitelisted = includes(whitelistedPages, props.pageType);
    const { getFeatureFlagValue, getExperimentValue } = useContext(
        ABeagleContext
    );

    async function initAdlib() {
        import(/* webpackChunkName: "bfadlib" */ '../../services/adlib')
            .then(
                (module) => setAdlib(module),
                (error) => {
                    setAdlib(
                        new AdError((error || {}).name || 'Unknown error')
                    );
                }
            );
    }

    useEffect(() => {
      if (!isWhitelisted) {
        return;
      } else if (!framework.needsGDPRConsent()) {
        initAdlib();
      } else {
        api.getTCData()
          .then(({ tcData }) => {
            if (!tcData.gdprApplies) {
              initAdlib();
            }
          });
      }

      if (!listener) {
        // wait for consent changes
        const _listener = api.setTCFListener(() => {
            rules.hasConsented('ads')
                // eslint-disable-next-line max-nested-callbacks
                .then((adsConsent) => {
                    if (adsConsent) {
                        initAdlib();
                    }
                });
        });
        setListener(_listener);
      }
    }, []); // call the hook once on mount

    // set context when adlib and ABeagle experiments have loaded; update on navigation
    useEffect(() => {
        if (!isWhitelisted) { return; }
        if (adlib instanceof AdError) {
            setContext({ error: adlib });
            return;
        }
        if (!adlib) { return; }

        getContext({
            page: { pageType: props.pageType },
            needsConsent: framework.needsConsent(),
            getFeatureFlagValue,
            getExperimentValue,
        }).then((contextValue) => {
            setContext(contextValue);
        });
    }, [adlib]);

    // init adlib with context
    useEffect(() => {
        if (
            !isWhitelisted ||
      !adlib ||
      (adlib instanceof AdError)
      || !context
        ) { return; }

        const ads = adlib.ads;
        ads.inject(context);
        ads.start();
    }, [adlib, context]);

    return (
        <AdsContext.Provider value={context}>
            { props.children }
        </AdsContext.Provider>
    );
}

Ads.propTypes = {
    pageType: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};
